import React from 'react';
import { LoaderSpinProps, LoaderSpin } from './LoaderSpin';
import { PageLayout } from '../layout/PageLayout';

export interface LoadingPageProps extends LoaderSpinProps {}

/**
 * Pagina di caricamento.
 */
export function LoadingPage(props: LoadingPageProps) {
  const { ...otherProps } = props;

  return (
    <PageLayout hasMainMenu>
      <LoaderSpin {...otherProps} transparent />
    </PageLayout>
  );
}
